import { createApiEndpoint } from "../../api/createApiEndpoint.js";
import * as global from "../../data/global";
import { saveSelectedSite } from "../../data/global";

let inflight = null;

const mapFetchUserSitesToSiteInfos = (sites) =>
    (sites || []).map((_, siteIndex) => ({
        siteIndex,
        siteGuid: _.siteGuid,
        siteName: _.main?.siteName ?? _.siteName ?? "Site",
        bins: _.bins,
        isHms: _.isHms,
        currentTemperature: _.currentTemperature,
        currentHumidity: _.currentHumidity,
        currentPressure: _.currentPressue,
        lastScanDate: _.lastScan ? new Date(String(_.lastScan).split(".")[0]) : null,
        lastScan: _.lastScan
            ? new Date(_.lastScan).toLocaleString("en-us", global.dateFormat).replaceAll("/", "-").replace(",", "")
            : "",
        taskSlots: Array.isArray(_.taskSlots) ? _.taskSlots : [],
        emailReportTo: _.main?.emailReportTo ?? _.emailReportTo ?? "",
        siteWeatherStationReadingSettings: [],
        siteWeatherStationReadings: (global.gw.currentWeatherReadings || []).filter(
            (x) => x.siteId === _.siteGuid,
        ),
    }));

const waitForAuthToken = async () => {
    if (global.gw.token) return true;
    for (let i = 0; i < 50; i += 1) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (global.gw.token) return true;
    }
    return Boolean(global.gw.token || global.gw.bolts);
};

const hydrateSelectedSiteName = () => {
    const selected = global.gw?.selectedSite;
    if (!selected?.siteGuid) return;
    const match = (global.gw.siteInfos || []).find(
        (s) =>
            global.normalizeGuidForCompare(s.siteGuid) ===
            global.normalizeGuidForCompare(selected.siteGuid),
    );
    if (match?.siteName && selected.siteName !== match.siteName) {
        selected.siteName = match.siteName;
        saveSelectedSite?.();
    }
};

const fetchUserSitesList = async () => {
    const tryMode = async (mode) => {
        const response = await createApiEndpoint().fetchUserSites(mode);
        return response?.data?.fetchUserAttribute?.sites;
    };
    try {
        const compressed = await tryMode("compressed");
        if (Array.isArray(compressed) && compressed.length) return compressed;
    } catch {
        // Fall through to uncompressed.
    }
    const direct = await tryMode("direct");
    return Array.isArray(direct) ? direct : [];
};

/**
 * Load `gw.siteInfos` once after a refresh so header site selectors can resolve names.
 * Shares an in-flight promise so Cable Health / Scan / pickers don't stampede.
 */
export async function ensureSiteInfosLoaded() {
    if (global.gw.siteInfos?.length > 0) {
        hydrateSelectedSiteName();
        return true;
    }
    if (inflight) return inflight;

    inflight = (async () => {
        try {
            const authed = await waitForAuthToken();
            if (!authed) return false;
            const sites = await fetchUserSitesList();
            if (!sites.length) return false;
            if (!(global.gw.siteInfos?.length > 0)) {
                global.gw.siteInfos = mapFetchUserSitesToSiteInfos(sites);
            }
            hydrateSelectedSiteName();
            return true;
        } catch (error) {
            console.error("[siteInfosCatalog] Failed to load site list", error);
            return false;
        } finally {
            inflight = null;
        }
    })();

    return inflight;
}
